import { IconButton, Tab, TabProps } from "@mui/material";
import { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function HideableTab(
  params: TabProps & {
    onSwitchVisibility: (value: string) => void;
    visible: boolean;
  }
) {
  const [isHovered, setIsHovered] = useState(false);
  const onIconClick = (event: React.MouseEvent) => {
    // Hinder the tab from being opened if the hide/unhide icon is clicked
    // The user should remain on the currently opened tab
    event.preventDefault();
    event.stopPropagation();
    // Notify that hide/unhide icon was clicked
    params.onSwitchVisibility(params.value);
  };

  return (
    <Tab
      {...params}
      key={`${params.value}-section-tab`}
      icon={
        !params.visible ? (
          <IconButton onClick={onIconClick}>
            <VisibilityOff fontSize="small" data-testid="VisibilityOffIcon" />
          </IconButton>
        ) : isHovered ? (
          <IconButton onClick={onIconClick}>
            <VisibilityIcon fontSize="small" data-testid="VisibilityOnIcon" />
          </IconButton>
        ) : (
          <></>
        )
      }
      iconPosition="end"
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
      wrapped
      onClick={params.visible ? params.onClick : undefined}
      onChange={params.visible ? params.onChange : undefined}
      sx={
        params.visible
          ? {}
          : { textDecoration: "line-through", color: "rgba(0, 0, 0, 0.38)" }
      }
      disableRipple={!params.visible}
    />
  );
}
